var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 107,
    viewBox: "0 0 173 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4347_29456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.934 10.2158V47.7951C127.178 47.7951 114.344 60.4686 114.344 76.1056C114.344 77.4928 114.471 78.8169 114.662 80.2041H42.3605C38.1037 80.2041 34.6094 76.7992 34.6094 72.5117V10.2158C34.6094 5.92827 38.0402 2.52344 42.3605 2.52344H135.183C137.152 2.52344 138.995 3.28007 140.393 4.47806C141.981 5.86522 142.934 7.94595 142.934 10.1528V10.2158Z",
    stroke: "#006052",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6484 4.98264L83.9173 51.8937C86.5222 54.4788 90.7154 54.4788 93.2568 51.8937L141.352 4.28906",
    stroke: "#006052",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75 76.5476C51.5698 60.8475 72.2182 40.3555 72.2182 40.3555",
    stroke: "#006052",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 40.3555L121.836 57.0644",
    stroke: "#006052",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.461 76.1074C171.461 91.8075 158.628 104.481 142.871 104.481C128.513 104.481 116.568 93.9513 114.599 80.2058C114.408 78.8817 114.281 77.4946 114.281 76.1074C114.281 60.4704 127.115 47.7969 142.871 47.7969C158.628 47.7969 171.461 60.4704 171.461 76.1074Z",
    stroke: "#FF7A2A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.906 74.2159L136.958 84.1152C137.213 84.4935 137.784 84.5565 138.102 84.2413L158.496 67.4062",
    stroke: "#FF7A2A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4347_29456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 107,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSend);
export default __webpack_public_path__ + "static/media/EmailSend.a3327c44278e8de810a56c78e7b794dc.svg";
export { ForwardRef as ReactComponent };